// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1l-FD","balanceDisclaimer":"posDashboard_balanceDisclaimer__2rgFQ"};